import React from "react";

export default function QuickMessageTemplates({ onSelectTemplate, isVisible, onClose }) {

  const templates = [
    {
      id: "still_available",
      text: "Hi! Is this item still available?",
      icon: "❓"
    },
    {
      id: "condition",
      text: "Could you tell me more about the condition of this item?",
      icon: "🔍"
    },
    {
      id: "price",
      text: "Is the price negotiable?",
      icon: "💰"
    },
    {
      id: "pickup",
      text: "Where can I pick this up?",
      icon: "📍"
    },
    {
      id: "more_photos",
      text: "Do you have more photos of this item?",
      icon: "📸"
    },
    {
      id: "age_range",
      text: "What age range is this suitable for?",
      icon: "👶"
    },
    {
      id: "hold_item",
      text: "Can you hold this item for me until [date]?",
      icon: "⏰"
    },
    {
      id: "meet_today",
      text: "Are you available to meet today?",
      icon: "🤝"
    },
    {
      id: "brand_model",
      text: "What brand and model is this?",
      icon: "🏷️"
    },
    {
      id: "warranty",
      text: "Does this come with any warranty or receipt?",
      icon: "📋"
    }
  ];

  const handleTemplateSelect = (template) => {
    onSelectTemplate(template.text);
    onClose();
  };


  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      />
      
      {/* Quick Templates Modal */}
      <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 w-full max-w-sm bg-white rounded-2xl shadow-xl z-50 max-h-[60vh] overflow-hidden border border-slate-200">
        {/* Header */}
        <div className="flex items-center justify-between p-3 border-b border-slate-200">
          <h3 className="text-base font-semibold text-slate-900">Quick Messages</h3>
          <button
            onClick={onClose}
            className="touch-target text-slate-500 hover:text-slate-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto max-h-[calc(70vh-140px)]">
          {/* Templates Grid */}
          <div className="p-3">
            <div className="grid grid-cols-1 gap-1.5">
              {templates.map((template) => (
                <button
                  key={template.id}
                  onClick={() => handleTemplateSelect(template)}
                  className="w-full text-left p-2.5 rounded-lg border border-slate-200 hover:border-blue-300 hover:bg-blue-50 transition-all duration-200 group"
                >
                  <div className="flex items-center gap-2">
                    <span className="text-lg">{template.icon}</span>
                    <span className="text-sm text-slate-700 group-hover:text-blue-700 flex-1">
                      {template.text}
                    </span>
                    <svg className="w-3 h-3 text-slate-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </button>
              ))}
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
